import { useMutation } from '@tanstack/react-query'
import api from '@/lib/api'
import { useAccessToken } from '@/features/auth/state/auth'

export function useAddSignature() {
  const token = useAccessToken()

  return useMutation({
    mutationFn: async ({ id_client, assinatura }: { id_client: string; assinatura: File }) => {
      if (!token) throw new Error('Token está ausente')
      if (!assinatura) throw new Error('Arquivo de assinatura é obrigatório')

      const formData = new FormData()
      formData.append('assinatura', assinatura)
      formData.append('cnpj', id_client)

      const response = await api.post('/signatures/client-assinatura/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`
        }
      })

      if (!response.data) throw new Error('Erro ao adicionar assinatura')
      return response.data
    }
  })
}
